// Shared by the browser, Node.js and edge Sentry setups.

type ScrubbableEvent = {
  request?: {
    url?: string;
    data?: unknown;
    query_string?: unknown;
    cookies?: Record<string, string>;
    headers?: { [key: string]: string };
  };
  user?: { id?: string | number; [key: string]: unknown };
  breadcrumbs?: Array<{ data?: { [key: string]: unknown } }>;
};

const PRIVATE_HEADERS = new Set(["cookie", "set-cookie", "authorization"]);

/**
 * Keeps a Sentry event to what debugging needs: no cookies, request bodies or
 * query strings, and of the member only the id.
 */
export function withoutMemberData<E extends ScrubbableEvent>(event: E): E {
  const scrubbed: ScrubbableEvent = event;
  const request = scrubbed.request;
  if (request) {
    delete request.cookies;
    delete request.data;
    delete request.query_string;
    if (request.url) request.url = request.url.split("?")[0];
    if (request.headers) {
      for (const name of Object.keys(request.headers)) {
        if (PRIVATE_HEADERS.has(name.toLowerCase())) delete request.headers[name];
      }
    }
  }
  if (scrubbed.user) scrubbed.user = { id: scrubbed.user.id };
  for (const crumb of scrubbed.breadcrumbs ?? []) {
    const url = crumb.data?.url;
    if (crumb.data && typeof url === "string") crumb.data.url = url.split("?")[0];
  }
  return event;
}
